// ILCS-116. Copies the visitor's GA4 client and session id onto the cart, so the server-side purchase the
// "GA4: web orders" Shopify Flow sends carries the same visitor as the browser events and GA4 can merge
// the two by transaction id. Only with analytics + sale-of-data consent (consent-mode.liquid); without
// it the ids are cleared and the order is marked denied, so the Flow skips it.
(function () {
  const script = document.currentScript;
  if (!script || window.__ilcGaCartAttributes) return;
  window.__ilcGaCartAttributes = true;

  const SESSION_COOKIE = '_ga_FLT2S3N51X';
  const RETRY_MS = Number(script.dataset.retryMs) || 2000;
  const MAX_RETRIES = 5;

  let itemCount = Number(script.dataset.itemCount) || 0;
  let saved = {
    client: script.dataset.client || '',
    session: script.dataset.session || '',
    consent: script.dataset.consent || '',
  };
  let consent = typeof window.__ilcAnalyticsConsent === 'boolean' ? window.__ilcAnalyticsConsent : null;
  let cookieWaits = 0;
  let failures = 0;
  let writing = false;
  let timer = null;

  const cookie = (name) => {
    const prefix = `${name}=`;
    const hit = document.cookie.split('; ').find((entry) => entry.startsWith(prefix));
    return hit ? decodeURIComponent(hit.slice(prefix.length)) : '';
  };

  // _ga is GA1.1.<random>.<first visit>: the client id is the last two parts.
  const clientId = () => {
    const match = /^GA\d\.\d+\.(\d+\.\d+)$/.exec(cookie('_ga'));
    return match ? match[1] : '';
  };

  // GS2.1.s<session start>$o... (current format) or GS1.1.<session start>.<count>... (older).
  const sessionId = () => {
    const value = cookie(SESSION_COOKIE);
    const match = /^GS2\.\d+\.s(\d+)/.exec(value) || /^GS1\.\d+\.(\d+)\./.exec(value);
    return match ? match[1] : '';
  };

  const wanted = () =>
    consent
      ? { client: clientId(), session: sessionId(), consent: 'granted' }
      : { client: '', session: '', consent: 'denied' };

  const later = () => {
    if (timer) return;
    timer = setTimeout(() => {
      timer = null;
      sync();
    }, RETRY_MS);
  };

  function sync() {
    if (consent === null || itemCount === 0 || writing) return;
    const next = wanted();
    // The Google channel pixel sets its cookies a moment after the page loads.
    if (consent && (!next.client || !next.session) && cookieWaits < MAX_RETRIES) {
      cookieWaits += 1;
      later();
      return;
    }
    if (consent && !next.client) return;
    if (next.client === saved.client && next.session === saved.session && next.consent === saved.consent) return;

    writing = true;
    fetch(`${window.FoxTheme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        attributes: { _ga_client_id: next.client, _ga_session_id: next.session, _ga_consent: next.consent },
      }),
    })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        saved = next;
        failures = 0;
      })
      .catch((error) => {
        failures += 1;
        console.error('ga-cart-attributes: saving the GA ids on the cart failed', error);
      })
      .finally(() => {
        writing = false;
        // A consent change or cookie that arrived during the save is picked up here.
        if (failures === 0) sync();
        else if (failures <= MAX_RETRIES) later();
      });
  }

  document.addEventListener('ilc:analytics-consent', (event) => {
    consent = Boolean(event.detail && event.detail.granted);
    sync();
  });

  const pubsub = window.FoxTheme && window.FoxTheme.pubsub;
  if (pubsub) {
    pubsub.subscribe(pubsub.PUB_SUB_EVENTS.cartUpdate, (data) => {
      const count = data && data.cart && data.cart.item_count;
      itemCount = typeof count === 'number' ? count : Math.max(itemCount, 1);
      sync();
    });
  }

  sync();
})();
